var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-bar"},[_c('img',{staticClass:"logo",attrs:{"src":"/dm-logo.webp"}}),_c('div')])
}]

export { render, staticRenderFns }